import { Navigate, useLocation } from 'react-router-dom'
import HomeRoute from '../HomeRoute'
import { canonicalHomeArrival } from './homeArrival'

export default function HomeArrivalRoute() {
  const location = useLocation()
  const target = canonicalHomeArrival(location)
  if (location.pathname !== target.pathname || location.search !== target.search)
    return <Navigate to={target} replace state={location.state} />
  return <HomeRoute />
}
